export default "__VITE_ASSET__Bhc6l5n1__"